import { api } from '../createApi';
import { TagType } from '../TagType';

export const TAG_CLAUSES = { type: TagType.Document, id: 'CLAUSES' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Document as TagType],
  endpoints: {
    getAllClausesGrouped: {
      providesTags: [TAG_CLAUSES],
    },
    getDocumentDetailClauses: {
      providesTags: [TAG_CLAUSES],
    },
  },
});
